import * as React from "react";
const SvgCheckmark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.66715 10.114L12.7954 3.98572L13.7382 4.92852L6.66715 11.9996L2.4245 7.75697L3.36731 6.81417L6.66715 10.114Z" }));
export default SvgCheckmark;
